import * as React from 'react'
import cn from 'classnames'

import ExpressDeliveryTag from './ExpressDeliveryTag'

import styles from './PriceExpressDeliveryTag.module.css'

type PriceTagProps = {
  expressDelivery?: '1h' | '24h'
  price: string
  originalPrice?: string
}

const PriceExpressDeliveryTag: React.FC<PriceTagProps> = ({
  expressDelivery,
  price,
  originalPrice,
}) => {
  return (
    <div className={styles.priceExpressOutContainer}>
      {expressDelivery && (
        <ExpressDeliveryTag expressDelivery={expressDelivery} />
      )}
      <div
        className={cn(styles.priceTagDefault, {
          [styles.priceTagDiscount]: !!originalPrice,
        })}
      >
        <span>{price}</span>
        <span
          className={cn({
            [styles.priceTagOriginalPrice]: !!originalPrice,
          })}
        >
          {originalPrice}
        </span>
      </div>
    </div>
  )
}

export default PriceExpressDeliveryTag
